import Stack from '@zenbusiness/zui/Stack';

import AccountSkeleton from './components/AccountSkeleton';

const TRANSACTION_ITEM_LOADING = 4;

export default function ListAccountSkeleton() {
  return (
    <Stack aria-label="Loading list of accounts">
      {Array.from({ length: TRANSACTION_ITEM_LOADING }, (_, key) => (
        <AccountSkeleton key={key} />
      ))}
    </Stack>
  );
}
